import { RFI as RFIModule } from '../../CIMSModule/instances'
import { Permission } from '../../permission'
import { RoleTemplateItem } from '../RoleTemplateItem'

const RFI = 'Request For Information'
const RFIWF = `${RFI} workflow`

export const RFIAdmin = new RoleTemplateItem({
  id: 'd0e6f7a2-5b8c-4f9d-8a1e-3b5c7d9f0e2a',
  name: `${RFI} Admin`,
  description: `Gives users access to all permissions within the ${RFIWF}`,
  module: RFIModule,
  permissionItems: Permission.findByModule(RFIModule),
})

export const RFICreator = new RoleTemplateItem({
  id: 'e1f7a8b3-6c9d-5a0e-9b2f-4c6d8e0f1a3b',
  name: `${RFI} Creator`,
  description: 'Allows users to Create new Requests For Information',
  module: RFIModule,
  permissionItems: [
    Permission.ViewRequestForInformation,
    Permission.CreateRequestForInformation,
    Permission.EditRequestForInformation,
    Permission.RevertRequestForInformation,
    Permission.RemoveRestoreRequestForInformation,
    Permission.CommentOnRequestForInformation,
    Permission.ViewRFINotification,
  ],
})

export const RFIViewOnly = new RoleTemplateItem({
  id: 'f2a8b9c4-7d0e-6b1f-0c3a-5d7e9f1a2b4c',
  name: `${RFI} View Only`,
  description: `Allows users to View the ${RFIWF} but not make any changes`,
  module: RFIModule,
  permissionItems: [
    Permission.ViewRequestForInformation,
    Permission.ViewRFINotification,
  ],
})

export type RFIRoleTemplateItem =
  | typeof RFIAdmin
  | typeof RFICreator
  | typeof RFIViewOnly
